import { z } from 'zod';
import { idSchema, paginated, paginationQuerySchema } from './common.js';
/**
 * Trilha de auditoria: quem, quando, o quê, valor antes/depois.
 * Registro imutável — a API não expõe update nem delete de AuditLog.
 */
export const AUDIT_ACTIONS = [
    'CREATE',
    'UPDATE',
    'DELETE',
    'RESTORE',
    'LOGIN',
    'LOGIN_FAILED',
    'LOGOUT',
    'REFRESH',
    'PASSWORD_CHANGE',
    'PASSWORD_RESET',
    'APPROVE',
    'REJECT',
    'EXPORT',
    'REVOKE',
];
export const auditActionSchema = z.enum(AUDIT_ACTIONS);
export const AUDIT_ACTION_LABELS = {
    CREATE: 'Criou',
    UPDATE: 'Alterou',
    DELETE: 'Excluiu',
    RESTORE: 'Restaurou',
    LOGIN: 'Entrou',
    LOGIN_FAILED: 'Falha de login',
    LOGOUT: 'Saiu',
    REFRESH: 'Renovou sessão',
    PASSWORD_CHANGE: 'Trocou a senha',
    PASSWORD_RESET: 'Redefiniu senha',
    APPROVE: 'Aprovou',
    REJECT: 'Reprovou',
    EXPORT: 'Exportou',
    REVOKE: 'Revogou',
};
export const auditLogSchema = z.object({
    id: idSchema,
    companyId: idSchema.nullable(),
    userId: idSchema.nullable(),
    userName: z.string().nullable(),
    action: auditActionSchema,
    entity: z.string(),
    entityId: z.string().nullable(),
    entityLabel: z.string().nullable(),
    method: z.string().nullable(),
    path: z.string().nullable(),
    statusCode: z.number().int().nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    requestId: z.string().nullable(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    changedFields: z.array(z.string()),
    /** Valor em centavos envolvido na ação, quando houver (baixa, estorno...). */
    amountCents: z.number().int().nullable(),
    reason: z.string().nullable(),
    createdAt: z.string(),
});
export const auditListQuerySchema = paginationQuerySchema.extend({
    entity: z.string().trim().max(80).optional(),
    entityId: z.string().trim().max(64).optional(),
    userId: idSchema.optional(),
    action: auditActionSchema.optional(),
    from: z.string().optional(),
    to: z.string().optional(),
});
export const auditListResponseSchema = paginated(auditLogSchema);
//# sourceMappingURL=audit.js.map